import React, { useState } from "react";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
    TextField,
    Button,
    Typography,
    Box,
    Alert,
    Stack,
} from "@mui/material";

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("token");
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    if (!token) {
        return (
            <Box maxWidth={400} mx="auto" mt={8} p={3} textAlign="center">
                <Typography variant="h6" color="error">
                    Invalid or missing verification token.
                </Typography>
            </Box>
        );
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setMessage("");

        if (password.length < 8) {
            setError("Password must be at least 8 characters long.");
            return;
        }
        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        try {
            const res = await axios.post(`${API_BASE_URL}/users/verify-email`, {
                token,
                password,
            });
            setMessage(res.data.message);
            setTimeout(() => {
                navigate("/login");
            }, 3000);
        } catch (err) {
            setError(err.response?.data?.detail || "Verification failed.");
        }
    };

    return (
        <Box maxWidth={400} mx="auto" mt={8} p={4} boxShadow={3} borderRadius={2} bgcolor="background.paper">
            <Typography variant="h5" component="h2" mb={3} textAlign="center">
                Email Verification & Password Setup
            </Typography>

            {message && (
                <Alert severity="success" sx={{ mb: 2 }}>
                    {message}
                </Alert>
            )}
            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}

            {!message && (
                <form onSubmit={handleSubmit}>
                    <Stack spacing={2}>
                        <TextField
                            label="New Password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            fullWidth
                            autoFocus
                        />
                        <TextField
                            label="Confirm Password"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            fullWidth
                        />
                        <Button variant="contained" type="submit" fullWidth>
                            Set Password & Verify
                        </Button>
                    </Stack>
                </form>
            )}
        </Box>
    );
};

export default VerifyEmail;
